// extracted by mini-css-extract-plugin
export default {"block":"zj","loading":"Aj","spinner":"Bj","spin":"Cj"};